import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

import { Icon, Tag } from 'common/components'

type Props = {
  expenseStatus: ExpenseStatus
}

const ExpenseStatusLabel = ({ expenseStatus }: Props) => {
  switch (expenseStatus) {
    case ExpenseStatus.Verified:
      return (
        <Tag key={expenseStatus} icon={<Icon className={'fal fa-check-circle mr-4'} />} color="success">
          Verified
        </Tag>
      )
    case ExpenseStatus.Ineligible:
      return (
        <Tag key={expenseStatus} icon={<Icon className={'fal fa-times-circle mr-4'} />} color="error">
          Rejected
        </Tag>
      )
    case ExpenseStatus.ActionRequired:
      return (
        <Tag key={expenseStatus} icon={<Icon className={'fal fa-exclamation-circle mr-4'} />} color="warning">
          Action Required
        </Tag>
      )
    default:
      return (
        <Tag key={expenseStatus} icon={<Icon className={'fal fa-clock mr-4'} />} color="processing">
          Awaiting Review
        </Tag>
      )
  }
}

export default ExpenseStatusLabel
